import parser from 'ua-parser-js'

export enum BrowserName {
  MOBILE_SAFARI = 'Mobile Safari',
  SAFARI = 'Safari',
}

export const getUserBrowser = () => {
  if (typeof navigator === 'undefined') return { browserName: undefined, browserVersion: undefined }
  const ua = parser(navigator.userAgent)
  return { browserName: ua.browser.name, browserVersion: ua.browser.version }
}

export const getOSDetails = () => {
  if (typeof navigator === 'undefined') return { osVersion: undefined, osName: undefined }
  const ua = parser(navigator.userAgent)
  return { osVersion: ua.os.version, osName: ua.os.name }
}

export const getIsAndroid = () => {
  if (typeof navigator === 'undefined') return false
  const ua = parser(navigator.userAgent)
  return (ua.os.name || '').toLowerCase().includes('android')
}
